import $ from "cash-dom";

export default (function () {
    $(document).ready(function () {
        var selector = "[data-flip-image]";

        if ($(selector).length) {
            if (log) console.log("%cfunction_flip-image.js initialized", "color: green;");
            var $button = $(selector).parents(".layout").find("[data-flip]");

            $button.on("click", function () {
                var $instance = $(this).parents(".layout").find(selector);
                $instance.toggleClass("on");
                $instance.parents(".layout").find(".stack").children().toggleClass("on pointer-none");
                $instance.removeClass("delay-lg");
                $button.find("svg").toggleClass("on");
            });
        }
    });
})();
